import { request } from "../helper/axios_helper";
import { getCurrentDateTimeInFormat } from "../helper/date_helper";

export const getMasterSuiteLibrary = (name) => {
  return request("GET", "/api/auth/mastersuite/fetch/library");
};

export const createNewMasterSuite = (
  masterSuiteName,
  comments,
  createdBy,
  defaultEnvironment
) => {
  const createdDate = getCurrentDateTimeInFormat();
  return request("POST", "/api/auth/mastersuite/save/master", {
    masterSuiteName: masterSuiteName,
    comments: comments,
    createdBy: createdBy,
    defaultEnvironment: defaultEnvironment,
    createdDate: createdDate,
  });
};

export const createNewMasterSuiteSteps = (stepData, masterSuiteName) => {
  return request(
    "POST",
    `/api/auth/mastersuite/save/steps/${masterSuiteName}`,
    stepData
  );
};

export const getMasterSuiteStepsByName = (name) => {
  return request("GET", `/api/auth/mastersuite/fetch/steps/${name}`);
};

// recreating=true is the edit/overwrite path (delete-then-recreate the same name),
// which the backend lets through even when the master suite is scheduled.
export const deleteMasterSuiteData = (name, { recreating = false } = {}) => {
  return request(
    "DELETE",
    `/api/auth/mastersuite/delete/${name}?recreating=${recreating}`,
  );
};
